import { convertSchemaToHtml } from '@thebeyondgroup/shopify-rich-text-renderer';

export async function updateFAQ() {
  const faqs = document.querySelectorAll('.panel-faq');

  if (!faqs.length) {return;}

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const faqHandle = urlParams.get('customFaqs');

  if (!faqHandle) {return;}

  const payload = {
    query: `query GetFAQSet($handle: MetaobjectHandleInput!) {
      metaobject(handle: $handle) { 
        field(key: "faqs") {
          references(first: 25) {
            edges {
              node {
                ... on Metaobject {
                  question: field(key: "question") {
                    value
                  }
                  answer: field(key: "answer") {
                    value
                  }
                }
              }
            }
          }
        }
      }
    }`,
    variables: {
        handle: { type: "faq_set", handle: faqHandle },
    },
  };

  const {storefrontApiToken} = window.themeConfiguration;
  const faqSetQuery = await fetch(
    `https://${window.shopifyDomain}/api/2024-04/graphql.json`,
    {
      method: 'POST',
      headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': storefrontApiToken,
      },
      body: JSON.stringify(payload),
    },
  );
  const data = await faqSetQuery.json();

  if (data.errors) {
    console.error('Error fetching FAQ set:', data.errors);
    return;
  }

  const faqFragments = data.data.metaobject.field.references.edges.map(({node}) => {
    const question = node.question.value;
    const answerHtml = convertSchemaToHtml(node.answer.value);
    return `
      <details name="faq">
        <summary>
          ${question}
        </summary>
        ${answerHtml}
      </details>
    `;
  });

  faqs.forEach((faqContainer) => {
      const innerContainer = faqContainer.querySelector('.faqs-list');
      if (!innerContainer) {return;}
      innerContainer.innerHTML = faqFragments.join('');
      innerContainer.querySelector('details').setAttribute('open', true);
  });
};
